import React, { useLayoutEffect, useRef } from 'react';

function DangerousHTMLContainer({ html }: { html: string }) {
  const divRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
    if (divRef && divRef.current) {
      divRef.current.innerHTML = ''; // Clear the container
      divRef.current.appendChild(slotHtml); // Append the new content
    }
  }, [html]);

  return <div ref={divRef} />;
}

export default DangerousHTMLContainer;
